import { render, staticRenderFns } from "./projectsReportedValues.vue?vue&type=template&id=0cd16836&scoped=true&"
import script from "./projectsReportedValues.vue?vue&type=script&lang=js&"
export * from "./projectsReportedValues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd16836",
  null
  
)

export default component.exports